import React, {useState} from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image} from "react-native";

import Config from "../../Config";
import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, EvilIcons, Ionicons} from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";
import Loading from "../Components/Loading";
import NumberFormat from "../Components/NumberFormat";
import AntDesign from "@expo/vector-icons/AntDesign";



const Packs =({navigation,route})=>{


    let [data, setData] = useState(false);




    React.useEffect(() => {
        getData();
    },[]);


    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/packs`,{ 'headers': {  Authorization: 'Bearer '+token} });
            console.log(res.data,'123');
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setData( res.data);

        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }


    const openLink = (id)=>{
        navigation.navigate('Pack',{course_id : id});


    }


    return (
        <View style={styles.container}>

            {data ?
                <>
                    <View style={styles.header}>
                        <Text style={styles.title}>
                            پک های ویژه هیمورا
                        </Text>



                        <View  style={{flex : 1}}>
                            {/*<TouchableOpacity onPress={()=>{navigation.navigate('InfoCategory')}}>*/}
                            {/*    <Text style={styles.title2}>*/}
                            {/*        جزئیات دوره*/}
                            {/*    </Text>*/}
                            {/*</TouchableOpacity>*/}
                        </View>

                        <TouchableOpacity onPress={()=>{navigation.navigate('Home')}}>
                            <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                        </TouchableOpacity>

                    </View>
                    {data.courses.length > 0 ?
                        <ScrollView >
                            <View style={styles.content}>


                                <>
                                    {data.courses.map( (item, index) =>
                                        <TouchableOpacity onPress={()=>openLink(item.id)} key={index} style={styles.item}>
                                            <View style={styles.image}>
                                                {/*<Image style={styles.image} source={{uri : `${Config.base}/${item.image}`}} />*/}
                                                <Image style={styles.image} source={{uri : `${Config.base}/${item.image}`}} />
                                                <View style={styles.subutem}>
                                                    {/*<Text style={styles.itmtxt}>*/}
                                                    {/*    دوره*/}
                                                    {/*</Text>*/}
                                                    {/*<Text style={styles.itmtitle}>*/}
                                                    {/*    IELTS*/}
                                                    {/*</Text>*/}
                                                </View>
                                            </View>
                                            <View >
                                                <View style={styles.rowitem}>
                                                    <Text style={styles.label}>
                                                        تعداد جلسات:
                                                    </Text>
                                                    <Text style={styles.val}>
                                                        {item.lessons_count}
                                                        درس
                                                    </Text>
                                                </View>
                                                <View style={styles.rowitem}>
                                                    <Text style={styles.label}>
                                                        مدت زمان:
                                                    </Text>
                                                    <Text style={styles.val}>
                                                        {item.time}
                                                    </Text>
                                                </View>
                                                <View style={styles.rowitem}>
                                                    {item.price  == 0 ?

                                                        <Text style={styles.label}>
                                                            رایگان
                                                        </Text>
                                                        :
                                                        <Text style={styles.labelbuy}>
                                                            خرید
                                                            {/*<EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />*/}
                                                            {` `}
                                                            (
                                                            <NumberFormat number={item.price} />
                                                            {` `}
                                                            )
                                                            تومان
                                                        </Text>

                                                    }
                                                </View>
                                            </View>

                                        </TouchableOpacity>
                                    )}
                                </>




                            </View>
                        </ScrollView>
                        :
                        <View style={{flex : 1 , justifyContent:'center', alignItems: 'center',marginTop : -RFValue(80)}}>
                            {/*<Image style={styles.sticker} source={{uri : `${Config.base}/images/sad.png`}}/>*/}

                            <Entypo name="open-book" size={RFValue(60)} color={Config.maincolor} />
                            <Text style={styles.nomsgtitle}>
                                به‌زودی با پک های جدید و جذاب در کنار شما خواهیم بود.
                            </Text>

                        </View>
                    }
                </>
                :
                <Loading/>
            }


        </View>
    );
}

const styles = StyleSheet.create({
    image: {
        width: RFValue(165),
        height: RFValue(110),
        borderRadius: RFValue(15),
        marginLeft : RFValue(10),
    },

    label : {
        fontFamily : 'ykb',
        color : '#0D1134',
        fontSize : RFValue(12),
    },
    labelbuy : {
        fontFamily : 'ykb',
        color : '#0D1134',
        fontSize : RFValue(10),
        backgroundColor: Config.secondcolor,
        // width : '60%',
        paddingHorizontal: RFValue(7),
        borderRadius : RFValue(10),
    },
    val : {
        fontFamily : 'yk',
        color : '#0D1134',
        marginRight : RFValue(4),
        fontSize : RFValue(12),
    },

    rowitem : {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems: 'flex-start',
        // backgroundColor:'red',
        width: '100%',
        paddingTop: RFValue(4),
    },

    item : {
        flexDirection : 'row',
        flex : 1,
        width: '99%',
        justifyContent : 'flex-start',
        alignItems : 'center',

        paddingVertical: RFValue(10),

    },

    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),

    },

    container : {
        flex: 1,
        backgroundColor: '#FAFAFA',
    },
    header: {



        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),


        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {

        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: Config.secondcolor,
        borderBottomColor : Config.secondcolor,
        borderBottomWidth : RFValue(3),
        paddingVertical: RFValue(14),
    },
    title2 : {
        fontSize: RFValue(16),
        fontFamily : 'yk',
        color: '#B2B4C4',
        marginRight: RFValue(20),

        borderBottomWidth : 1,
        paddingVertical: RFValue(14),
    },

    subutem:{
        width: '75%',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor : 'red',
        // float: 'left',
        position: 'relative',
        top : -RFValue(100),
        left : -RFValue(50),
    },

    itmtxt : {
        fontSize: RFValue(17),
        fontFamily : 'yk',
        color: 'white',
        textAlign: 'center',
    },
    itmtitle : {
        fontSize: RFValue(17),
        fontFamily : 'yk',
        color: '#0D1134',
        textAlign: 'center',
        backgroundColor: 'white',
        borderRadius: RFValue(18),
        padding: RFValue(8),
        marginTop: RFValue(8),
    },
    sticker  : {
        width: RFValue(60),
        height: RFValue(60),
        marginBottom : RFValue(20),
    },
    nomsgtitle : {
        fontSize: RFValue(14),
        fontFamily : 'ykb',
        color: Config.maincolor,
        marginTop:RFValue(20),


    },
    nomsgsubtext : {
        fontSize: RFValue(12),
        fontFamily : 'yk',
        color: Config.maincolor,
        paddingVertical: RFValue(14),
    },
    cart : {
        backgroundColor: Config.secondcolor,
        // width: '100%',
        width: RFValue(145),
        flexBasis: 'auto',
        flexShrink : 'auto',
        padding : RFValue(3),
        height : RFValue(22),
        borderRadius: 20,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: RFValue(5),
    },

})


export default Packs;